import DataTable from "react-data-table-component";
import { customTableStyles } from "../utils";


const CustomPagination = ({ columns, data, total, isFetching, onChangePage, onChangeRowsPerPage, paginationDefaultPage, ...rest }) => {


    return (
        <>
            <DataTable
                paginationServer // Enable server-side pagination
                paginationTotalRows={total} // Total number of rows in the table
                onChangePage={onChangePage} // Handle page change
                onChangeRowsPerPage={onChangeRowsPerPage} // Handle per page change
                paginationDefaultPage={paginationDefaultPage} // Set the current page


                columns={columns}
                data={data}
                customStyles={customTableStyles}
                pagination={true}
                progressPending={isFetching}
                progressComponent={<>
                    <span className="loading d-flex align-items-center justify-content-center"
                        style={{ height: 200 }}>
                        <i className="ri-loader-2-fill fs-25 rotation"></i>
                    </span>
                </>}
                {...rest}


            />
        </>
    )
}

export default CustomPagination